// CRM feature entry — Pipeline board, Contacts table (+ contact page/drawer), Next moves.
// Pages are code-split; each wraps itself in <RequireIgAccount> where it needs one.
import { ListChecks, SquareKanban, UsersRound } from "lucide-react";
import { Navigate, useParams } from "react-router";
import type { FeatureModule } from "../registry";

/** `/crm/<contactId>` (what the Instagram overlay's "Open in GramFather" opens) → the contact page. */
function ContactRedirect() {
  const { contactId = "" } = useParams();
  return <Navigate to={`/crm/contacts/${encodeURIComponent(contactId)}`} replace />;
}

const crm: FeatureModule = {
  id: "crm",
  nav: [
    { to: "/crm", label: "Pipeline", icon: SquareKanban, group: "pipeline", order: 10, end: true },
    { to: "/crm/contacts", label: "Contacts", icon: UsersRound, group: "pipeline", order: 20 },
    { to: "/crm/tasks", label: "Next moves", icon: ListChecks, group: "pipeline", order: 30 },
  ],
  routes: [
    { path: "/crm", lazy: async () => ({ Component: (await import("./BoardPage")).BoardPage }) },
    { path: "/crm/contacts", lazy: async () => ({ Component: (await import("./ContactsPage")).ContactsPage }) },
    { path: "/crm/contacts/:contactId", lazy: async () => ({ Component: (await import("./ContactPage")).ContactPage }) },
    { path: "/crm/tasks", lazy: async () => ({ Component: (await import("./TasksPage")).TasksPage }) },
    { path: "/crm/:contactId", element: <ContactRedirect /> },
  ],
};

export default crm;
